import React from "react";
import { Icon } from "../../../icons/icons";
import { useTranslation } from "../../../context/TranslationContext";

const GuestInformationSuccessfully = ({ setOpen }) => {
  const {
    GuestInformationSuccessfullyTitle,
    GuestInformationSuccessfullyDescription,
    close,
  } = useTranslation();
  return (
    <div className=" flex flex-col items-center justify-center h-full mb-10">
      <div className="flex flex-col justify-center items-center text-center md:w-[571px]">
        <div className="text-[#4BAE4F] mb-4">
          <Icon name={"guestconfirmation"} size={60}></Icon>
        </div>
        <span className="text-dark text-[23px] font-semibold">
          {GuestInformationSuccessfullyTitle}
        </span>
        <span className="text-[#637176] text-13 font-medium mb-10">
          {GuestInformationSuccessfullyDescription}
        </span>
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="py-[10px] px-[17px] rounded bg-red-400 hover:bg-red-800  duration-200 text-white text-sm font-bold"
        >
          {close}
        </button>
      </div>
    </div>
  );
};

export default GuestInformationSuccessfully;
